import React, { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import anokhee from '../Images/anokhee.jpg'

import copy from '../Images/copy.png'

import copyGreen from '../Images/copy_green.png'

function MyProf() {

  const { id } = useParams()

  const [thisDoctor, setThisDoctor] = useState({

    specialities: []

  })

  const handleIdCopy = async (pId) => {

    try {

      await navigator.clipboard.writeText(pId);

      alert('Patient ID copied to clipboard!');

    } catch (error) {

      console.error('Failed to copy:', error);

    }

  };

  const handleContactCopy = async (pCon) => {

    try {

      await navigator.clipboard.writeText(pCon);

      alert('Contact copied to clipboard!');

    } catch (error) {

      console.error('Failed to copy:', error);

    }

  };

const [age, setAge] = useState("");



  const calAge = (birthdate) => {

    const today = new Date();

    const birthDate = new Date(birthdate);

    let calculatedAge = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();



    if (

      monthDifference < 0 ||

      (monthDifference === 0 && today.getDate() < birthDate.getDate())

    ) {

      calculatedAge--;

    }

    setAge(calculatedAge);

  };



  useEffect(() => {

    calAge(thisDoctor.birthdate);

  }, [thisDoctor?.birthdate]);



  const getDoctorInformation = async () => {

    try {

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/doctor/${id}/`, {

        method: 'GET',

        headers: {

          'Content-Type': 'application/json',

        },

        mode: 'cors'

      });

      const json = await response.json();

      if (response.ok) {

        setThisDoctor(json);

      }

    } catch (error) {

      console.error('Failed to fetch doctor information:', error);

    }

  }



  useEffect(() => {

    getDoctorInformation();

  }, [id]);



  return (

    <div className='dash2'>

     

      <div className="d2Scroll">

        <div className="d2Top">

        <img src={anokhee} alt="search" />

          <div className="desc">

            <div className="dtd">

              <p>Name: <b>Anokhee Naik</b></p>

              <p>Age: <b>36</b></p>

              <p>Gender: <b>Female</b></p>

            </div>

            <div className="dtd">

              <p>Address: <b>Vadodara, Gujarat</b></p>

            </div>

          </div>

        </div>



        <div className='scInfo mySpecs'>

          <h1>My Specialities</h1>

          <p>General</p>

          <div className="specs">

            {thisDoctor.specialities.map((specialty) => (

              <label key={specialty.id}>

                <input

                  type="checkbox"

                  checked={true}

                  disabled={true}

                />

                {specialty.name}

              </label>

            ))}

          </div>

        </div>



      </div>



    </div>

  )

}



export default MyProf